import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';

import Meta from '../Meta';
import TickerGraph from '../../components/graph/TickerGraph';
import withTickerSubscribe from '../../hoc/withTickerSubscribe';
import { formatNumber } from '../../service/market';
import normalizeSymbol from '../../service/normalizesymbol';

import css from '../../styles/instrument/header';

function mapStateToProps(state, props) {
    const tickers = state.tickers;

    return {
        ...(tickers[normalizeSymbol(props.symbol)] || {}),
    };
}


class Header extends Component {
    static propTypes = {
        symbol: PropTypes.string.isRequired,
        title: PropTypes.string.isRequired,
        LONG_NAME: PropTypes.string,
        SECURITYNAME: PropTypes.string,
        SECTOR: PropTypes.string,
        ITEM: PropTypes.string,
        LAST: PropTypes.number,
        LASTNZ: PropTypes.number,
        TIME: PropTypes.number,
        INSTRUMENT_TYPE: PropTypes.string,
        CURRENCY: PropTypes.string,
        CHANGE_PCT: PropTypes.number,
        CLOSE_CA_BEGIN_1DAY: PropTypes.number,
        CLOSE_BEGIN_1DAY: PropTypes.number,

        CHANGE: PropTypes.number,
        CHANGE_7DAYS: PropTypes.number,
        CHANGE_7DAYS_PCT: PropTypes.number,
        CHANGE_MONTH: PropTypes.number,
        CHANGE_MONTH_PCT: PropTypes.number,
        CHANGE_YEAR: PropTypes.number,
        CHANGE_YEAR_PCT: PropTypes.number,
        CHANGE_1YEAR: PropTypes.number,
        CHANGE_1YEAR_PCT: PropTypes.number,
        CHANGE_5YEARS: PropTypes.number,
        CHANGE_5YEARS_PCT: PropTypes.number,
        CHANGE_10YEARS: PropTypes.number,
        CHANGE_10YEARS_PCT: PropTypes.number,

        noGraph: PropTypes.bool,
        breakpoint: PropTypes.bool,
    }

    renderSymbol() {
        // @TODO: Return null if it's a custom OMS symbol, like oil or gold.
        // Or even better, print a meaningful text, like "1 fat nordsjøolje"
        if (!this.props.symbol) {
            return null;
        }

        return (
            <div className={css.symbol}>
                <span>{ this.props.symbol }</span>
            </div>
        );
    }

    renderCurrency() {
        const { CURRENCY, SECTOR } = this.props;

        const currencySector = 'IDCFX';

        let currency;

        if (CURRENCY) {
            currency = CURRENCY;
        } else if (SECTOR && SECTOR === currencySector) {
            // @TODO: Shows wrong on foreign currency,
            // i.e. instrument/X:SUSDSEK.IDCFX
            currency = 'SEK';
        } else {
            return null;
        }

        return <span className={css.currency}>{currency}</span>;
    }

    renderLast() {
        // @TODO: If no last value (Market is closed), try using different prop
        // i.e CLOSE_CA_BEGIN_1DAY with a faded text color.
        const { LAST, LASTNZ, CLOSE_CA_BEGIN_1DAY } = this.props;

        const number = formatNumber(LAST || LASTNZ || CLOSE_CA_BEGIN_1DAY);

        return (
            <div className={css.last}>
                <span>{number}{this.renderCurrency()}</span>
            </div>
        );
    }

    renderChange() {
        // @TODO: Show time and countdown to when stock opens if no CHANGE* props
        const { CHANGE, CHANGE_PCT, breakpoint } = this.props;

        const value = CHANGE || CHANGE_PCT || 0;

        let sign;
        const classNames = [];
        if (value === 0) {
            classNames.push(css.neutral);
        } else if (value > 0) {
            sign = '+';
            classNames.push(css.positive);
        } else {
            sign = '-';
            classNames.push(css.negative);
        }

        if (breakpoint) {
            classNames.push(css.breakpoint);
        }

        return (
            <div className={classNames.join(' ')}>
                <span className={css.changeText}>
                    {typeof CHANGE === 'undefined' ? (
                        <span className={css.changePct}>
                            {sign}{formatNumber(Math.abs(CHANGE_PCT || 0))}
                            <span className={css.percentage}>%</span>
                        </span>
                    ) : (
                        <span>
                            <span className={css.change}>
                                {sign}{formatNumber(Math.abs(CHANGE || 0))}
                            </span> <span className={css.changePct}>
                                ({formatNumber(Math.abs(CHANGE_PCT || 0))}
                                <span className={css.percentage}>%</span>)
                            </span>
                        </span>
                    )}
                </span>
            </div>
        );
    }

    render() {
        return (
            <div>
                <Meta pageName={this.props.title} />
                <div className={css.header}>
                    {this.renderSymbol()}
                    <div className={css.title}>
                        <span>{ this.props.LONG_NAME || this.props.SECURITYNAME}</span>
                    </div>
                </div>
                <div className={css.values}>
                    { this.renderLast() }
                    { this.renderChange() }
                </div>
                {!this.props.noGraph ? (
                    <TickerGraph
                        key={this.props.symbol}
                        symbol={this.props.symbol}
                        height={180}
                        showButtons
                        close={this.props.CLOSE_CA_BEGIN_1DAY || this.props.CLOSE_BEGIN_1DAY}
                        CHANGE_PCT={this.props.CHANGE_PCT}
                        CHANGE_7DAYS={this.props.CHANGE_7DAYS}
                        CHANGE_7DAYS_PCT={this.props.CHANGE_7DAYS_PCT}
                        CHANGE_MONTH={this.props.CHANGE_MONTH}
                        CHANGE_MONTH_PCT={this.props.CHANGE_MONTH_PCT}
                        CHANGE_YEAR={this.props.CHANGE_YEAR}
                        CHANGE_YEAR_PCT={this.props.CHANGE_YEAR_PCT}
                        CHANGE_1YEAR={this.props.CHANGE_1YEAR}
                        CHANGE_1YEAR_PCT={this.props.CHANGE_1YEAR_PCT}
                        CHANGE_5YEARS={this.props.CHANGE_5YEARS}
                        CHANGE_5YEARS_PCT={this.props.CHANGE_5YEARS_PCT}
                        CHANGE_10YEARS={this.props.CHANGE_10YEARS}
                        CHANGE_10YEARS_PCT={this.props.CHANGE_10YEARS_PCT}
                        LAST={this.props.LAST}
                        TIME={this.props.TIME}
                    />
                ) : ''}
            </div>
        );
    }
}

export default connect(mapStateToProps)(withTickerSubscribe(Header));



/** WEBPACK FOOTER **
 ** /src/shared/containers/instrument/Header.js
 **/